import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Writes a construction-frame key into a building's ordered list at `index`.
// Construction frames are a THEME asset stored in the top-level
// constructionImagePacks dict (keyed by building id), NOT on BuildingData. Used
// by the upload pipeline when a fresh image is added to an empty slot
// (index === current length, i.e. an append). Replacing a filled slot reuses the
// existing key in place, so it doesn't go through here.
export class SetBuildingConstructionImageCommand extends CommandBase {
    constructor(private buildingId: string, private index: number, private key: string) {
        super();
    }

    execute(data: RemoteConstantsModel): boolean {
        if (!data.constructionImagePacks) data.constructionImagePacks = {};
        const frames = data.constructionImagePacks[this.buildingId] ?? [];
        // Guard against gaps — only set within or directly after the list.
        if (this.index > frames.length) return false;
        frames[this.index] = this.key;
        data.constructionImagePacks[this.buildingId] = frames;
        return true;
    }
}

// Removes the construction frame at `index`, shifting later frames down (no
// gaps). Cleans up an emptied building entry.
export class RemoveBuildingConstructionImageCommand extends CommandBase {
    constructor(private buildingId: string, private index: number) {
        super();
    }

    execute(data: RemoteConstantsModel): boolean {
        const frames = data.constructionImagePacks?.[this.buildingId];
        if (!frames || this.index < 0 || this.index >= frames.length) return false;
        frames.splice(this.index, 1);
        if (frames.length === 0) delete data.constructionImagePacks[this.buildingId];
        return true;
    }
}
